import moment from 'moment';
const filterVisibleMailTags = (tags) => {
    const visibleTags = Array.from(new Set((tags || []).filter(tag => tag && !tag.startsWith('%') && !tag.endsWith('%'))));
    return visibleTags.length > 0 ? visibleTags : undefined;
};
export const reducerHelper = {
    updateMailEntity(mailEntities, type, mapResult) {
        if (mapResult) {
            mapResult.forEach((item, id) => {
                if (mailEntities[id]) {
                    switch (type) {
                        case 'read': {
                            mailEntities[id].entry.readStatus = item.readStatus ? 'read' : 'unread';
                            return;
                        }
                        case 'requestReadReceiptLocal': {
                            mailEntities[id].entry.requestReadReceiptLocal = item.requestReadReceiptLocal;
                            return;
                        }
                        case 'memo': {
                            mailEntities[id].entry.memo = item.memo;
                            return;
                        }
                        case 'redFlag': {
                            mailEntities[id].entry.mark = item.redFlag ? 'redFlag' : 'none';
                            return;
                        }
                        case 'preferred': {
                            mailEntities[id].entry.preferred = item.preferred ? 1 : 0;
                            return;
                        }
                        case 'tag': {
                            mailEntities[id].tags = filterVisibleMailTags(item.tags);
                            return;
                        }
                        case 'top': {
                            mailEntities[id].entry.top = item.rank === -10;
                            return;
                        }
                        case 'reply': {
                            mailEntities[id].entry.replayed = item.replyStatus;
                            mailEntities[id].entry.forwarded = item.forwardStatus;
                            return;
                        }
                        case 'defer': {
                            mailEntities[id].entry.isDefer = !!item.isDefer;
                            mailEntities[id].entry.deferTime = moment(item.deferTime).format('YYYY-MM-DD HH:mm:ss');
                            mailEntities[id].entry.deferNotice = !!item.deferNotice;
                            return;
                        }
                        case 'suspiciousSpam': {
                            mailEntities[id].entry.suspiciousSpam = !!item.suspiciousSpam;
                            return;
                        }
                        case 'markFolder': {
                            mailEntities[id].entry.readStatus = item.readStatus ? 'read' : 'unread';
                            return;
                        }
                    }
                }
            });
        }
    },
    updateMailEntityByEvent(mailEntities, type, eventData) {
        if (eventData.params) {
            const { mid, id: mailId, ids, add, isDefer, conf } = eventData.params || {};
            const id = Array.isArray(ids) && ids.length ? ids[0] : mailId || mid;
            if (mailEntities[id]) {
                switch (type) {
                    case 'read': {
                        mailEntities[id].entry.readStatus = eventData.params.mark ? 'read' : 'unread';
                        return;
                    }
                    case 'redFlag': {
                        mailEntities[id].entry.mark = eventData.params.mark ? 'redFlag' : 'none';
                        return;
                    }
                    case 'tag': {
                        if (add && add.length) {
                            mailEntities[id].tags = filterVisibleMailTags([...(mailEntities[id].tags || []), ...add]);
                        }
                        return;
                    }
                    case 'defer': {
                        const { deferTime, deferNotice } = conf || {};
                        if (deferTime) {
                            mailEntities[id].entry.isDefer = !!isDefer;
                            mailEntities[id].entry.deferTime = moment(deferTime).format('YYYY-MM-DD HH:mm:ss');
                            mailEntities[id].entry.deferNotice = !!deferNotice;
                        }
                        return;
                    }
                }
            }
        }
    },
};
